<template>
	<div class="list">
		<button @click="getTotalTimedCount">
			get total timed count
		</button>
		<br />
		<br />
		<select placeholder="Genre filter" v-model="filter">
			<option disabled>Genre filter</option>
			<option v-for="t in musicTypes" :key="t.id" :value="t.id">{{
				t.title
			}}</option>
		</select>
		<label style="margin-left: 8px"> count: {{ songs.length }} </label>
		<label style="margin-left: 8px">
			✅ {{ parsedCount.true }} ❌ {{ parsedCount.false }}
		</label>
		<div v-if="songs.length">
			<div v-for="(song, index) in songs" :key="song.id + song_key">
				<div class="line">
					<div v-if="checkIsLong(song)" class="longCount">
						{{ checkIsLong(song) }}
					</div>
					<div
						class="checkbox"
						@click="set_checked(song.id, song.parsed, index)"
					>
						<v-icon
							v-if="song.parsed"
							name="check"
							class="check_icon"
							scale="1.5"
						/>
					</div>
					<h2 class="song_title">{{ song.title }} – {{ song.artist }}</h2>
					<router-link
						:to="'/timer/' + song.id"
						style="color: crimson"
						target="_blank"
					>
						<v-icon name="snowplow" scale="4" style="cursor: pointer" />
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { getMusicTypes, db } from "../../../firebase";
import { isLongSentences } from "@/helpers/songStates.js";

export default {
	props: ["select"],
	data() {
		return {
			songs: [],
			filter: "Genre filter",
			musicTypes: [],
			parsedCount: { true: 0, false: 0 },
			song_key: 0,
			//counts
			counts: {
				en: {},
			},
			counts_key: 0,
		};
	},
	watch: {
		filter(filter) {
			this.$store.commit("setMusicGenre", filter);
			this.getSongs(filter);
		},
		songs(list) {
			this.countParsed(list);
		},
	},

	mounted() {
		const { musicGenre } = this.$store.state;
		if (musicGenre) this.filter = musicGenre;
		getMusicTypes().then((mtypes) => (this.musicTypes = mtypes));
	},
	methods: {
		set_checked(id, current, index) {
			this.songs[index].parsed = !this.songs[index].parsed;
			this.song_key++;
			this.$songs.doc(id).set({ parsed: !current }, { merge: true });
			if (this.songs[index].parsed) {
				const count = this.parsedCount.true;
				db.collection("music_genre")
					.doc(this.filter)
					.set({ count: count + 1 }, { merge: true });
				this.parsedCount.true++;
				this.parsedCount.false--;
			}
		},
		count() {
			const { songs } = this;
			for (let i = 0; i < songs.length; i++) {
				const lang = songs[i].lang;
				const type = songs[i].music_type;
				if (!this.counts[lang][type]) this.counts[lang][type] = 1;
				else this.counts[lang][type]++;
			}
			this.counts_key++;
		},
		countParsed(list) {
			this.parsedCount.true = list.filter((s) => s.parsed).length;
			this.parsedCount.false = list.filter((s) => !s.parsed).length;
		},
		getSongs(genre) {
			const songFilter = (song) => song.lang === "en";
			this.$songs
				.where("music_type", "==", genre)
				.get()
				.then((docs) => {
					this.songs = docs.docs
						.map((doc) => doc.data())
						.filter(songFilter)
						.sort((a, b) => (a.parsed && !b.parsed ? 1 : -1));

					this.count();
				});
		},
		getTotalTimedCount() {
			this.$songs
				.where("lang", "==", "en")
				.get()
				.then((docs) => {
					const songs = docs.docs.map((doc) => doc.data());
					const timed = songs.filter((song) => song.parsed);
					alert(timed.length);
				});
		},
		checkIsLong(song) {
			return isLongSentences(song);
		},
	},
};
</script>

<style scoped>
.list {
	width: 80%;
	margin: auto;
}
.line {
	display: flex;
	align-items: center;
	justify-content: left;
	margin: 8px 0;
}
.song_title {
	text-align: left;
	flex: 1;
	border-bottom: 1px solid lightgrey;
}
.checkbox {
	width: 33px;
	height: 33px;
	border: 1px solid lightgrey;
	margin-right: 32px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}
.check_icon {
	color: var(--green);
}
button {
	padding: 8px;
	cursor: pointer;
}
.longCount {
	color: red;
	margin-right: 8px;
	font-size: 20px;
}
</style>
